/** "jUAN carlos  gomez" → "Juan Carlos Gomez" (cada palabra con inicial mayúscula, espacios colapsados). */
const capitalizeName = (str) =>
  str
    ? str.trim().replace(/\s+/g, ' ').toLowerCase().replace(/(^|\s)\S/g, (m) => m.toUpperCase())
    : str;

export default capitalizeName;
